import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Toolbar, Tooltip, IconButton, Typography, OutlinedInput, InputAdornment } from '@material-ui/core';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  paddingLeft: 0,
  paddingRight : 0,
  padding: theme.spacing(0, 0, 0, 0)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

TicketsToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func
};

export default function TicketsToolbar({ numSelected, filterName, onFilterName }) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const wordCount = filterName?.trim().split(/\s+/).filter(Boolean).length || 0;
  const isOverLimit = wordCount >= 25;
  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: isLight ? 'primary.main' : 'text.primary',
          bgcolor: isLight ? '#05191f' : '#05191f'
        }),
        padding: 0
      }}
    >
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <SearchStyle
        sx={{backgroundColor:'#05191f',
          ...(isOverLimit && {
            '& fieldset': {
              borderColor: theme.palette.error.main + ' !important'
            }
          })
        }}
          value={filterName}
          onChange={(e) => {
            const input = e.target.value;
            const words = input.trim().split(/\s+/).filter(Boolean);
          
            if (words.length <= 25) {
              onFilterName(e);
            } else {
              const trimmedInput = words.slice(0, 25).join(' ') + ' ';
              const syntheticEvent = {
                ...e,
                target: {
                  ...e.target,
                  value: trimmedInput
                }
              };
              onFilterName(syntheticEvent);
            }
          }}
          // onChange={onFilterName}
          placeholder="Search Tickets..."
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
        />
        {isOverLimit && (
              <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                Maximum 25 words allowed.
              </Typography>
            )}
        </Box>
      {numSelected > 0 && (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      
        
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Icon icon={trash2Fill} />
          </IconButton>
        </Tooltip>
      ) : null
      // (
      //   <Tooltip title="Filter list">
      //     <IconButton>
      //       <Icon icon={roundFilterList} />
      //     </IconButton>
      //   </Tooltip>
      // )
      }
    </RootStyle>
  );
}
